/**
 * Initializes the mobile menu offcanvas and accordion submenus.
 */
export const initMobileMenuOffcanvas = (): void => {
  const toggleBtn = document.querySelector<HTMLButtonElement>(
    ".mobile-menu-toggle",
  );
  const panel = document.querySelector<HTMLElement>(".mobile-menu-panel");
  const body = document.body;

  if (!toggleBtn || !panel) return;

  const toggleMenu = () => {
    const isExpanded = toggleBtn.getAttribute("aria-expanded") === "true";
    const newState = !isExpanded;

    toggleBtn.setAttribute("aria-expanded", String(newState));
    panel.classList.toggle("is-open", newState);
    body.style.overflow = newState ? "hidden" : "";
  };

  toggleBtn.addEventListener("click", toggleMenu);

  const submenuToggles = panel.querySelectorAll<HTMLButtonElement>(
    ".mobile-menu-offcanvas__submenu-toggle",
  );

  submenuToggles.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation(); // Diğer tıklamalarla çakışmasını engeller

      const parentItem = btn.closest("li");
      if (parentItem) {
        // Toggle the class
        const isCurrentlyOpen = parentItem.classList.contains("is-open");

        if (isCurrentlyOpen) {
          parentItem.classList.remove("is-open");
          btn.setAttribute("aria-expanded", "false");
        } else {
          parentItem.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
        }
      }
    });
  });

  console.log("[MobileMenu] Initialized Offcanvas & Accordion.");
};
